import React from 'react';
import { Container } from 'react-bootstrap';
import AboutUsSection from '../../components/ui/AboutUsSection';
import Meta from '../../components/layout/Meta';

const AboutUsScreen = () => {
    return (
        <>
            <Meta title="Quiénes somos | HomeSanty" />
            <Container className="py-4 py-md-5">
                <AboutUsSection />
            </Container>
        </>
    );
};

export default AboutUsScreen;
